module.exports = __webpack_public_path__ + "img/ic_scan.8107b696.svg";